const minValue = 16
const maxValue = 35

export { minValue, maxValue }